module.exports = __webpack_public_path__ + "static/media/works_sp.867f8235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/works_sp.jpg
// module id = 490
// module chunks = 0